import styled from 'styled-components'

export const Form = styled.form`
  label {
    margin-bottom: 20px;
  }
`
